/** サイドバーの行の見た目。場所の行とツリーの行で揃える */

export function sourceRowClass(isActive: boolean): string {
  return `flex items-center gap-2 rounded-md px-2 py-1.5 text-[13px] transition-colors min-w-0 ${
    isActive ? 'bg-accent text-accent-foreground font-medium' : 'text-foreground/90 hover:bg-muted'
  }`
}

/** プロジェクトの移動（@dnd-kit）の受け口に重なっているとき */
export function dropHighlight(isOver: boolean): string {
  return isOver ? 'ring-2 ring-primary/40 bg-primary/10' : ''
}

/** OS からのファイルの受け口に重なっているとき。移動と見分けられるよう破線にする */
export function fileDropHighlight(isOver: boolean): string {
  return isOver ? 'outline-2 outline-dashed outline-primary bg-primary/10' : ''
}
